import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=87cc28a0&scoped=true"
import script from "./QuizList.vue?vue&type=script&lang=js"
export * from "./QuizList.vue?vue&type=script&lang=js"
import style0 from "./QuizList.vue?vue&type=style&index=0&id=87cc28a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc28a0",
  null
  
)

export default component.exports